(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-json'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var protoOf = kotlin_kotlin.$_$.w4;
  var objectMeta = kotlin_kotlin.$_$.v4;
  var setMetadataFor = kotlin_kotlin.$_$.x4;
  var Unit_instance = kotlin_kotlin.$_$.m2;
  var classMeta = kotlin_kotlin.$_$.y3;
  var VOID = kotlin_kotlin.$_$.e;
  var Enum = kotlin_kotlin.$_$.r5;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.f;
  var lazy = kotlin_kotlin.$_$.n6;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.p;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.w;
  var THROW_CCE = kotlin_kotlin.$_$.w5;
  var equals = kotlin_kotlin.$_$.a4;
  var hashCode = kotlin_kotlin.$_$.f4;
  var joinToString = kotlin_kotlin.$_$.i3;
  var Map = kotlin_kotlin.$_$.v2;
  var List = kotlin_kotlin.$_$.t2;
  var toString = kotlin_kotlin.$_$.z4;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.s;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var getBooleanHashCode = kotlin_kotlin.$_$.c4;
  var getStringHashCode = kotlin_kotlin.$_$.e4;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.c2;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var toLongOrNull = kotlin_kotlin.$_$.m5;
  var toULongOrNull = kotlin_kotlin.$_$.n5;
  var ULong = kotlin_kotlin.$_$.e6;
  var Companion_getInstance = kotlin_kotlin.$_$.k2;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.n1;
  var toDoubleOrNull = kotlin_kotlin.$_$.l5;
  var toBooleanStrictOrNull = kotlin_kotlin.$_$.k5;
  var isInterface = kotlin_kotlin.$_$.o4;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t;
  var lazy_0 = kotlin_kotlin.$_$.o6;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var KProperty1 = kotlin_kotlin.$_$.e5;
  var getPropertyCallableRef = kotlin_kotlin.$_$.d4;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var interfaceMeta = kotlin_kotlin.$_$.g4;
  var toLong = kotlin_kotlin.$_$.y4;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.h1;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.j1;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.m1;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.o1;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.c1;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.e1;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.r1;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.t1;
  var captureStack = kotlin_kotlin.$_$.u3;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var charSequenceLength = kotlin_kotlin.$_$.w3;
  var charSequenceSubSequence = kotlin_kotlin.$_$.x3;
  var coerceAtLeast = kotlin_kotlin.$_$.a5;
  var coerceAtMost = kotlin_kotlin.$_$.b5;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var fillArrayVal = kotlin_kotlin.$_$.b4;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var objectCreate = kotlin_kotlin.$_$.u4;
  var ensureNotNull = kotlin_kotlin.$_$.k6;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var OBJECT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.p6;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var SerializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var isFinite = kotlin_kotlin.$_$.m6;
  var isFinite_0 = kotlin_kotlin.$_$.l6;
  var toString_0 = kotlin_kotlin.$_$.y;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.j2;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.i2;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.l2;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var setOf = kotlin_kotlin.$_$.l3;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var numberToChar = kotlin_kotlin.$_$.t4;
  var charSequenceGet = kotlin_kotlin.$_$.v3;
  var enumEntries = kotlin_kotlin.$_$.r3;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.i;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Json, 'Json', classMeta);
  setMetadataFor(Default, 'Default', objectMeta, Json);
  setMetadataFor(JsonClassDiscriminator, 'JsonClassDiscriminator', classMeta);
  setMetadataFor(JsonConfiguration, 'JsonConfiguration', classMeta);
  setMetadataFor(ClassDiscriminatorMode, 'ClassDiscriminatorMode', classMeta, Enum);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(JsonElement, 'JsonElement', classMeta, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  setMetadataFor(JsonPrimitive, 'JsonPrimitive', classMeta, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  setMetadataFor(JsonNull, 'JsonNull', objectMeta, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(JsonObject, 'JsonObject', classMeta, JsonElement, [JsonElement, Map], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(JsonArray, 'JsonArray', classMeta, JsonElement, [JsonElement, List], VOID, VOID, {0: JsonArraySerializer_getInstance});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(JsonLiteral, 'JsonLiteral', classMeta, JsonPrimitive);
  setMetadataFor(JsonElementSerializer, 'JsonElementSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonNullSerializer, 'JsonNullSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonObjectDescriptor, 'JsonObjectDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonObjectSerializer, 'JsonObjectSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonArrayDescriptor, 'JsonArrayDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonArraySerializer, 'JsonArraySerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonLiteralSerializer, 'JsonLiteralSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(defer$1, VOID, classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonEncoder, 'JsonEncoder', interfaceMeta, VOID, [Encoder, CompositeEncoder]);
  setMetadataFor(Composer, 'Composer', classMeta);
  setMetadataFor(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', classMeta, Composer);
  setMetadataFor(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', classMeta, Composer);
  setMetadataFor(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', classMeta, Composer);
  setMetadataFor(JsonException, 'JsonException', classMeta, SerializationException);
  setMetadataFor(JsonEncodingException, 'JsonEncodingException', classMeta, JsonException);
  setMetadataFor(Key, 'Key', classMeta, VOID, VOID, Key);
  setMetadataFor(DescriptorSchemaCache, 'DescriptorSchemaCache', classMeta, VOID, VOID, DescriptorSchemaCache);
  setMetadataFor(StreamingJsonEncoder, 'StreamingJsonEncoder', classMeta, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  setMetadataFor(WriteMode, 'WriteMode', classMeta, Enum);
  setMetadataFor(JsonToStringWriter, 'JsonToStringWriter', classMeta, VOID, VOID, JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.wn_1 = configuration;
    this.xn_1 = serializersModule;
    this.yn_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).wf = function () {
    return this.xn_1;
  };
  protoOf(Json).zn = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.bo();
    }
  };
  function JsonClassDiscriminator() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.co_1 = encodeDefaults;
    this.do_1 = ignoreUnknownKeys;
    this.eo_1 = isLenient;
    this.fo_1 = allowStructuredMapKeys;
    this.go_1 = prettyPrint;
    this.ho_1 = explicitNulls;
    this.io_1 = prettyPrintIndent;
    this.jo_1 = coerceInputValues;
    this.ko_1 = useArrayPolymorphism;
    this.lo_1 = classDiscriminator;
    this.mo_1 = allowSpecialFloatingPointValues;
    this.no_1 = useAlternativeNames;
    this.oo_1 = namingStrategy;
    this.po_1 = decodeEnumsCaseInsensitive;
    this.qo_1 = allowTrailingComma;
    this.ro_1 = classDiscriminatorMode;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.co_1 + ', ignoreUnknownKeys=' + this.do_1 + ', isLenient=' + this.eo_1 + ', ' + ('allowStructuredMapKeys=' + this.fo_1 + ', prettyPrint=' + this.go_1 + ', explicitNulls=' + this.ho_1 + ', ') + ("prettyPrintIndent='" + this.io_1 + "', coerceInputValues=" + this.jo_1 + ', useArrayPolymorphism=' + this.ko_1 + ', ') + ("classDiscriminator='" + this.lo_1 + "', allowSpecialFloatingPointValues=" + this.mo_1 + ', ') + ('useAlternativeNames=' + this.no_1 + ', namingStrategy=' + this.oo_1 + ', decodeEnumsCaseInsensitive=' + this.po_1 + ', ') + ('allowTrailingComma=' + this.qo_1 + ', classDiscriminatorMode=' + this.ro_1 + ')');
  };
  var ClassDiscriminatorMode_NONE_instance;
  var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  var ClassDiscriminatorMode_POLYMORPHIC_instance;
  var ClassDiscriminatorMode_entriesInitialized;
  function ClassDiscriminatorMode_initEntries() {
    if (ClassDiscriminatorMode_entriesInitialized)
      return Unit_instance;
    ClassDiscriminatorMode_entriesInitialized = true;
    ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
    ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
    ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
  }
  function ClassDiscriminatorMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClassDiscriminatorMode_NONE_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_NONE_instance;
  }
  function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_POLYMORPHIC_instance;
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance_3() {
    return Companion_instance;
  }
  function JsonElement() {
  }
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.to_1.p1();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.so_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.to_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull).uo = function () {
    return this.so_1;
  };
  protoOf(JsonNull).vo = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull).sj = function (typeParamsSerializers) {
    return this.vo();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    // Inline function 'kotlin.collections.component1' call
    var k = _name_for_destructuring_parameter_0__wldtmu.o1();
    // Inline function 'kotlin.collections.component2' call
    var v = _name_for_destructuring_parameter_0__wldtmu.p1();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(this_0, k);
    this_0.g4(_Char___init__impl__6a9atx(58));
    this_0.e4(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.wo_1 = content;
  }
  protoOf(JsonObject).n1 = function () {
    return this.wo_1.n1();
  };
  protoOf(JsonObject).k1 = function () {
    return this.wo_1.k1();
  };
  protoOf(JsonObject).m = function () {
    return this.wo_1.m();
  };
  protoOf(JsonObject).xo = function (key) {
    return this.wo_1.s1(key);
  };
  protoOf(JsonObject).s1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.xo((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).yo = function (key) {
    return this.wo_1.u1(key);
  };
  protoOf(JsonObject).u1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.yo((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).q = function () {
    return this.wo_1.q();
  };
  protoOf(JsonObject).equals = function (other) {
    return equals(this.wo_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.wo_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.wo_1.n1();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.zo_1 = content;
  }
  protoOf(JsonArray).m = function () {
    return this.zo_1.m();
  };
  protoOf(JsonArray).ap = function (elements) {
    return this.zo_1.p(elements);
  };
  protoOf(JsonArray).p = function (elements) {
    return this.ap(elements);
  };
  protoOf(JsonArray).w = function (index) {
    return this.zo_1.w(index);
  };
  protoOf(JsonArray).q = function () {
    return this.zo_1.q();
  };
  protoOf(JsonArray).n = function () {
    return this.zo_1.n();
  };
  protoOf(JsonArray).equals = function (other) {
    return equals(this.zo_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.zo_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.zo_1, ',', '[', ']');
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.uo();
  };
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_2(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.bp_1 = isString;
    this.cp_1 = coerceToInlineType;
    this.dp_1 = toString(body);
    if (!(this.cp_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.cp_1.vd()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).uo = function () {
    return this.dp_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.bp_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.dp_1);
      tmp = this_0.toString();
    } else {
      tmp = this.dp_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.bp_1 === other.bp_1))
      return false;
    if (!(this.dp_1 === other.dp_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.bp_1);
    result = imul(31, result) + getStringHashCode(this.dp_1) | 0;
    return result;
  };
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.dd('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.dd('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.dd('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.dd('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.dd('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().ep_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().fp_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().gp_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().hp_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().ip_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.jp_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).tc = function () {
    return this.jp_1;
  };
  protoOf(JsonElementSerializer).kp = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.tf(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.tf(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.tf(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).uc = function (encoder, value) {
    return this.kp(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.fp_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).tc = function () {
    return this.fp_1;
  };
  protoOf(JsonNullSerializer).lp = function (encoder, value) {
    verify(encoder);
    encoder.xe();
  };
  protoOf(JsonNullSerializer).uc = function (encoder, value) {
    return this.lp(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.mp_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).tc();
    this.np_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).td = function () {
    return this.mp_1.td();
  };
  protoOf(JsonObjectDescriptor).ud = function () {
    return this.mp_1.ud();
  };
  protoOf(JsonObjectDescriptor).vd = function () {
    return this.mp_1.vd();
  };
  protoOf(JsonObjectDescriptor).od = function () {
    return this.mp_1.od();
  };
  protoOf(JsonObjectDescriptor).wd = function () {
    return this.mp_1.wd();
  };
  protoOf(JsonObjectDescriptor).xd = function (index) {
    return this.mp_1.xd(index);
  };
  protoOf(JsonObjectDescriptor).yd = function (index) {
    return this.mp_1.yd(index);
  };
  protoOf(JsonObjectDescriptor).sd = function () {
    return this.np_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.hp_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).tc = function () {
    return this.hp_1;
  };
  protoOf(JsonObjectSerializer).op = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).uc(encoder, value);
  };
  protoOf(JsonObjectSerializer).uc = function (encoder, value) {
    return this.op(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.pp_1 = ListSerializer(JsonElementSerializer_getInstance()).tc();
    this.qp_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).td = function () {
    return this.pp_1.td();
  };
  protoOf(JsonArrayDescriptor).ud = function () {
    return this.pp_1.ud();
  };
  protoOf(JsonArrayDescriptor).vd = function () {
    return this.pp_1.vd();
  };
  protoOf(JsonArrayDescriptor).od = function () {
    return this.pp_1.od();
  };
  protoOf(JsonArrayDescriptor).wd = function () {
    return this.pp_1.wd();
  };
  protoOf(JsonArrayDescriptor).xd = function (index) {
    return this.pp_1.xd(index);
  };
  protoOf(JsonArrayDescriptor).yd = function (index) {
    return this.pp_1.yd(index);
  };
  protoOf(JsonArrayDescriptor).sd = function () {
    return this.qp_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.ip_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).tc = function () {
    return this.ip_1;
  };
  protoOf(JsonArraySerializer).rp = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).uc(encoder, value);
  };
  protoOf(JsonArraySerializer).uc = function (encoder, value) {
    return this.rp(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.ep_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).tc = function () {
    return this.ep_1;
  };
  protoOf(JsonPrimitiveSerializer).sp = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.tf(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.tf(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).uc = function (encoder, value) {
    return this.sp(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.gp_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).tc = function () {
    return this.gp_1;
  };
  protoOf(JsonLiteralSerializer).tp = function (encoder, value) {
    verify(encoder);
    if (value.bp_1) {
      return encoder.gf(value.dp_1);
    }
    if (!(value.cp_1 == null)) {
      return encoder.hf(value.cp_1).gf(value.dp_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.dp_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.cf(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.dp_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).bc_1;
      var tmp_1 = encoder.hf(serializer_0(Companion_getInstance()).tc());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.cf(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.dp_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.ef(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.dp_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.ye(tmp3_safe_receiver);
    }
    encoder.gf(value.dp_1);
  };
  protoOf(JsonLiteralSerializer).uc = function (encoder, value) {
    return this.tp(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + getKClassFromExpression(_this__u8e3s4)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.up_1;
    original$factory();
    return this_0.p1();
  }
  function defer$1($deferred) {
    this.up_1 = lazy_0($deferred);
  }
  protoOf(defer$1).sd = function () {
    return _get_original__l7ku1m(this).sd();
  };
  protoOf(defer$1).wd = function () {
    return _get_original__l7ku1m(this).wd();
  };
  protoOf(defer$1).ud = function () {
    return _get_original__l7ku1m(this).ud();
  };
  protoOf(defer$1).yd = function (index) {
    return _get_original__l7ku1m(this).yd(index);
  };
  protoOf(defer$1).xd = function (index) {
    return _get_original__l7ku1m(this).xd(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.xp_1 = writer;
    this.yp_1 = true;
  }
  protoOf(Composer).zp = function () {
    this.yp_1 = true;
  };
  protoOf(Composer).aq = function () {
    return Unit_instance;
  };
  protoOf(Composer).bq = function () {
    this.yp_1 = false;
  };
  protoOf(Composer).cq = function () {
    this.yp_1 = false;
  };
  protoOf(Composer).dq = function () {
    return Unit_instance;
  };
  protoOf(Composer).eq = function (v) {
    return this.xp_1.fq(v);
  };
  protoOf(Composer).gq = function (v) {
    return this.xp_1.hq(v);
  };
  protoOf(Composer).iq = function (v) {
    return this.xp_1.hq(v.toString());
  };
  protoOf(Composer).jq = function (v) {
    return this.xp_1.hq(v.toString());
  };
  protoOf(Composer).kq = function (v) {
    return this.xp_1.lq(toLong(v));
  };
  protoOf(Composer).mq = function (v) {
    return this.xp_1.lq(toLong(v));
  };
  protoOf(Composer).nq = function (v) {
    return this.xp_1.lq(toLong(v));
  };
  protoOf(Composer).oq = function (v) {
    return this.xp_1.lq(v);
  };
  protoOf(Composer).pq = function (v) {
    return this.xp_1.hq(v.toString());
  };
  protoOf(Composer).qq = function (value) {
    return this.xp_1.rq(value);
  };
  function Composer_0(sb, json) {
    return json.wn_1.go_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.uq_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).nq = function (v) {
    if (this.uq_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.qq(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.gq(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).oq = function (v) {
    if (this.uq_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.qq(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.gq(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).kq = function (v) {
    if (this.uq_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.qq(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.gq(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).mq = function (v) {
    if (this.uq_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.qq(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.gq(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.xq_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).qq = function (value) {
    if (this.xq_1) {
      protoOf(Composer).qq.call(this, value);
    } else {
      protoOf(Composer).gq.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.ar_1 = json;
    this.br_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).zp = function () {
    this.yp_1 = true;
    this.br_1 = this.br_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).aq = function () {
    this.br_1 = this.br_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).bq = function () {
    this.yp_1 = false;
    this.gq('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.br_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.gq(this.ar_1.wn_1.io_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).cq = function () {
    if (this.yp_1)
      this.yp_1 = false;
    else {
      this.bq();
    }
  };
  protoOf(ComposerWithPrettyPrint).dq = function () {
    this.eq(_Char___init__impl__6a9atx(32));
  };
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.sd() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.wd() + "'.\n") + get_allowStructuredMapKeysHint());
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    // Inline function 'kotlin.text.substring' call
    var startIndex = coerceAtLeast(start_0, 0);
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output)));
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.yd(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.wd(), CLASS_getInstance()) ? json.wn_1.oo_1 : null;
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.dr(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.ud();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.yd(tmp_2);
        tmp_1[tmp_2] = $strategy.er($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function encodeByWriter(json, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = get_entries().m();
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
    encoder.tf(serializer, value);
  }
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.td().n();
    while (tmp0_iterator.u()) {
      var annotation = tmp0_iterator.v();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.nr_1;
    }
    return json.wn_1.lo_1;
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.tc()).o(classDiscriminator)) {
      var baseName = serializer.tc().sd();
      var actualName = actualSerializer.tc().sd();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.cr_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).or = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.cr_1;
    var value_0 = this_0.u1(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.l1(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.l1(key_0, value_1);
  };
  protoOf(DescriptorSchemaCache).dr = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.pr(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.or(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).pr = function (descriptor, key) {
    var tmp0_safe_receiver = this.cr_1.u1(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.u1(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.fr_1.bq();
    $this.gf(ensureNotNull($this.mr_1));
    $this.fr_1.eq(get_COLON());
    $this.fr_1.dq();
    $this.gf(descriptor.sd());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.fr_1 = composer;
    this.gr_1 = json;
    this.hr_1 = mode;
    this.ir_1 = modeReuseCache;
    this.jr_1 = this.gr_1.wf();
    this.kr_1 = this.gr_1.wn_1;
    this.lr_1 = false;
    this.mr_1 = null;
    var i = this.hr_1.n6_1;
    if (!(this.ir_1 == null)) {
      if (!(this.ir_1[i] === null) ? true : !(this.ir_1[i] === this)) {
        this.ir_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).vp = function () {
    return this.gr_1;
  };
  protoOf(StreamingJsonEncoder).wf = function () {
    return this.jr_1;
  };
  protoOf(StreamingJsonEncoder).wp = function (element) {
    this.tf(JsonElementSerializer_getInstance(), element);
  };
  protoOf(StreamingJsonEncoder).zf = function (descriptor, index) {
    return this.kr_1.co_1;
  };
  protoOf(StreamingJsonEncoder).tf = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.vp().wn_1.ko_1) {
        serializer.uc(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.vp().wn_1.ro_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.vp().wn_1.ro_1.n6_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call

            var it = serializer.tc().wd();
            tmp_0 = equals(it, CLASS_getInstance()) ? true : equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.tc(), this.vp()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (value == null) {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call
            var message = 'Value for serializer ' + serializer.tc() + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          validateIfSealed$accessor$1ad0flx(serializer, actual, baseClassDiscriminator);
        }
        checkKind(actual.tc().wd());
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
        this.mr_1 = baseClassDiscriminator;
      }
      actualSerializer.uc(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).te = function (descriptor) {
    var newMode = switchMode(this.gr_1, descriptor);
    if (!(newMode.sr_1 === get_INVALID())) {
      this.fr_1.eq(newMode.sr_1);
      this.fr_1.zp();
    }
    if (!(this.mr_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.mr_1 = null;
    }
    if (this.hr_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.ir_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.n6_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.fr_1, this.gr_1, newMode, this.ir_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).ue = function (descriptor) {
    if (!(this.hr_1.tr_1 === get_INVALID())) {
      this.fr_1.aq();
      this.fr_1.cq();
      this.fr_1.eq(this.hr_1.tr_1);
    }
  };
  protoOf(StreamingJsonEncoder).ve = function (descriptor, index) {
    switch (this.hr_1.n6_1) {
      case 1:
        if (!this.fr_1.yp_1) {
          this.fr_1.eq(get_COMMA());
        }

        this.fr_1.bq();
        break;
      case 2:
        if (!this.fr_1.yp_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.fr_1.eq(get_COMMA());
            this.fr_1.bq();
            tmp_0 = true;
          } else {
            this.fr_1.eq(get_COLON());
            this.fr_1.dq();
            tmp_0 = false;
          }
          tmp.lr_1 = tmp_0;
        } else {
          this.lr_1 = true;
          this.fr_1.bq();
        }

        break;
      case 3:
        if (index === 0)
          this.lr_1 = true;
        if (index === 1) {
          this.fr_1.eq(get_COMMA());
          this.fr_1.dq();
          this.lr_1 = false;
        }

        break;
      default:
        if (!this.fr_1.yp_1) {
          this.fr_1.eq(get_COMMA());
        }

        this.fr_1.bq();
        this.gf(getJsonElementName(descriptor, this.gr_1, index));
        this.fr_1.eq(get_COLON());
        this.fr_1.dq();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).uf = function (descriptor, index, serializer, value) {
    if (!(value == null) ? true : this.kr_1.ho_1) {
      protoOf(AbstractEncoder).uf.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).hf = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.fr_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.fr_1;
      } else {
        tmp_0 = new ComposerForUnsignedNumbers(this.fr_1.xp_1, this.lr_1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.gr_1, this.hr_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.fr_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.fr_1;
      } else {
        tmp_2 = new ComposerForUnquotedLiterals(this.fr_1.xp_1, this.lr_1);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.gr_1, this.hr_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).hf.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).xe = function () {
    this.fr_1.gq(get_NULL());
  };
  protoOf(StreamingJsonEncoder).ye = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.pq(value);
    }
  };
  protoOf(StreamingJsonEncoder).ze = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.kq(value);
    }
  };
  protoOf(StreamingJsonEncoder).af = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.mq(value);
    }
  };
  protoOf(StreamingJsonEncoder).bf = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.nq(value);
    }
  };
  protoOf(StreamingJsonEncoder).cf = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.oq(value);
    }
  };
  protoOf(StreamingJsonEncoder).df = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.iq(value);
    }
    if (!this.kr_1.mo_1 ? !isFinite(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.fr_1.xp_1));
    }
  };
  protoOf(StreamingJsonEncoder).ef = function (value) {
    if (this.lr_1) {
      this.gf(value.toString());
    } else {
      this.fr_1.jq(value);
    }
    if (!this.kr_1.mo_1 ? !isFinite_0(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.fr_1.xp_1));
    }
  };
  protoOf(StreamingJsonEncoder).ff = function (value) {
    this.gf(toString_0(value));
  };
  protoOf(StreamingJsonEncoder).gf = function (value) {
    return this.fr_1.qq(value);
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.vd() ? get_unsignedNumberDescriptors().o(_this__u8e3s4) : false;
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.vd() ? equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor()) : false;
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).tc(), serializer_0(Companion_getInstance()).tc(), serializer_2(Companion_getInstance_1()).tc(), serializer_3(Companion_getInstance_2()).tc()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.g4(get_STRING());
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length ? !(get_ESCAPE_STRINGS()[c] == null) : false) {
          _this__u8e3s4.c6(value, lastPos, i);
          _this__u8e3s4.f4(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.c6(value, lastPos, value.length);
    } else {
      _this__u8e3s4.f4(value);
    }
    _this__u8e3s4.g4(get_STRING());
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.arrayOfNulls' call
      var this_0 = fillArrayVal(Array(93), null);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_0(c1) + toString_0(c2) + toString_0(c3) + toString_0(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      this_7[Char__toInt_impl_vasixd(this_8)] = 34;
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(92);
      this_7[Char__toInt_impl_vasixd(this_9)] = 92;
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(9);
      this_7[Char__toInt_impl_vasixd(this_10)] = 116;
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(8);
      this_7[Char__toInt_impl_vasixd(this_11)] = 98;
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(10);
      this_7[Char__toInt_impl_vasixd(this_12)] = 110;
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(13);
      this_7[Char__toInt_impl_vasixd(this_13)] = 114;
      this_7[12] = 102;
      ESCAPE_MARKERS = this_7;
    }
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_LIST_instance = new WriteMode('LIST', 1, get_BEGIN_LIST(), get_END_LIST());
    WriteMode_MAP_instance = new WriteMode('MAP', 2, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, get_BEGIN_LIST(), get_END_LIST());
  }
  var $ENTRIES;
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.sr_1 = begin;
    this.tr_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.wd();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.xd(0), _this__u8e3s4.wf());
          var keyKind = keyDescriptor.wd();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.wn_1.fo_1) {
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.wd(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.vd()) {
      tmp = carrierDescriptor(_this__u8e3s4.xd(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function get_STRING() {
    return STRING;
  }
  var STRING;
  function get_COLON() {
    return COLON;
  }
  var COLON;
  function get_BEGIN_OBJ() {
    return BEGIN_OBJ;
  }
  var BEGIN_OBJ;
  function get_END_OBJ() {
    return END_OBJ;
  }
  var END_OBJ;
  function get_BEGIN_LIST() {
    return BEGIN_LIST;
  }
  var BEGIN_LIST;
  function get_END_LIST() {
    return END_LIST;
  }
  var END_LIST;
  function get_specialFlowingValuesHint() {
    return specialFlowingValuesHint;
  }
  var specialFlowingValuesHint;
  function get_allowStructuredMapKeysHint() {
    return allowStructuredMapKeysHint;
  }
  var allowStructuredMapKeysHint;
  function get_INVALID() {
    return INVALID;
  }
  var INVALID;
  function get_COMMA() {
    return COMMA;
  }
  var COMMA;
  function get_NULL() {
    return NULL;
  }
  var NULL;
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.yn_1;
  }
  function JsonToStringWriter() {
    this.ao_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).lq = function (value) {
    this.ao_1.f6(value);
  };
  protoOf(JsonToStringWriter).fq = function (char) {
    this.ao_1.g4(char);
  };
  protoOf(JsonToStringWriter).hq = function (text) {
    this.ao_1.f4(text);
  };
  protoOf(JsonToStringWriter).rq = function (text) {
    printQuoted(this.ao_1, text);
  };
  protoOf(JsonToStringWriter).bo = function () {
    this.ao_1.h6();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.ao_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).od = get_isNullable;
  protoOf(defer$1).vd = get_isInline;
  protoOf(defer$1).td = get_annotations;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  STRING = _Char___init__impl__6a9atx(34);
  COLON = _Char___init__impl__6a9atx(58);
  BEGIN_OBJ = _Char___init__impl__6a9atx(123);
  END_OBJ = _Char___init__impl__6a9atx(125);
  BEGIN_LIST = _Char___init__impl__6a9atx(91);
  END_LIST = _Char___init__impl__6a9atx(93);
  specialFlowingValuesHint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
  allowStructuredMapKeysHint = "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.";
  INVALID = _Char___init__impl__6a9atx(0);
  COMMA = _Char___init__impl__6a9atx(44);
  NULL = 'null';
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Default_getInstance;
  _.$_$.b = JsonNull_getInstance;
  _.$_$.c = JsonArray;
  _.$_$.d = JsonEncoder;
  _.$_$.e = JsonObject;
  _.$_$.f = JsonPrimitive_2;
  _.$_$.g = JsonPrimitive_0;
  _.$_$.h = JsonPrimitive_1;
  //endregion
  return _;
}));
